import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../utils/propUtils';
import VeltCommentDialogSuggestionAuthorAvatarWireframe from './VeltCommentDialogSuggestionAuthorAvatarWireframe/VeltCommentDialogSuggestionAuthorAvatarWireframe';
import VeltCommentDialogSuggestionAuthorNameWireframe from './VeltCommentDialogSuggestionAuthorNameWireframe/VeltCommentDialogSuggestionAuthorNameWireframe';
var VeltCommentDialogSuggestionAuthorWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-suggestion-author-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogSuggestionAuthorWireframe.Avatar = VeltCommentDialogSuggestionAuthorAvatarWireframe;
VeltCommentDialogSuggestionAuthorWireframe.Name = VeltCommentDialogSuggestionAuthorNameWireframe;
export default VeltCommentDialogSuggestionAuthorWireframe;
